<app-app-loader *ngIf="isLoading"></app-app-loader>
<section class="analyticsHome bannerCont" #pageRoot [style.opacity]="isLoading ? 0 : 1">
    <h1 class="displayHeadingText">Welcome To <span>DMINT Analytics</span> Data-Driven Decisions & Insights Start Here!</h1>
    <div class="flexSP h32 mtb8 dontShow">
        <h2 class="displayHeadingText-sml">{{totalResultCount}} Analytics</h2>
        <hr *ngIf="false" class="vertical">
        <h2 *ngIf="false" class="displayHeadingText-sml">5 Brands</h2>
    </div>
    <div class="kpiCont">
        <div #tickerContent class="ticker-content">
            <div class="kpiItem">
                <div class="kpiLabel">Analytics Data Products</div>
                <div class="kpiValue"><span>+280</span> (All Business Lines)</div>
            </div>
            <div class="kpiItem">
                <div class="kpiLabel">Tyre Referential</div>
                <div class="kpiValue"><span>+400k</span> Products (Worldwide)</div>
            </div>
            <div class="kpiItem">
                <div class="kpiLabel">Vehicle Referential</div>
                <div class="kpiValue"><span>+40k</span> Models (Worldwide)</div>
            </div>
            <div class="kpiItem">
                <div class="kpiLabel">Sellout & Product Availability</div>
                <div class="kpiValue"><span>Direct & Syndicated</span> Data Collection</div>
            </div>
            <div class="kpiItem">
                <div class="kpiLabel">Car Parc PCLT</div>
                <div class="kpiValue">European Scope</div>
            </div>
            <div class="kpiItem">
                <div class="kpiLabel">Pricing & eRetail</div>
                <div class="kpiValue"><span>+300</span> Websites Scraped (Worldwide)</div>
            </div>
            <div class="kpiItem">
                <div class="kpiLabel">Michelin Websites Analytics</div>
                <div class="kpiValue"><span>User Intelligence</span> Performance Monitoring</div>
            </div>
            
            <div class="kpiItem">
                <div class="kpiLabel">Analytics Data Products</div>
                <div class="kpiValue"><span>{{totalResultCount}}</span> (All Business Lines)</div>
            </div>
            <div class="kpiItem">
                <div class="kpiLabel">Tyre Referential</div>
                <div class="kpiValue"><span>+400k</span> Products (Worldwide)</div>
            </div>
            <div class="kpiItem">
                <div class="kpiLabel">Vehicle Referential</div>
                <div class="kpiValue"><span>+40k</span> Models (Worldwide)</div>
            </div>
            <div class="kpiItem">
                <div class="kpiLabel">Sellout & Product Availability</div>
                <div class="kpiValue"><span>Direct & Syndicated</span> Data Collection</div>
            </div>
            <div class="kpiItem">
                <div class="kpiLabel">Car Parc PCLT</div>
                <div class="kpiValue">European Scope</div>
            </div>
            <div class="kpiItem">
                <div class="kpiLabel">Pricing & eRetail</div>
                <div class="kpiValue"><span>+300</span> Websites Scraped (Worldwide)</div>
            </div>
            <div class="kpiItem">
                <div class="kpiLabel">Michelin Websites Analytics</div>
                <div class="kpiValue"><span>User Intelligence</span> Performance Monitoring</div>
            </div>
        </div>
    </div>
  
</section>
<section class="wrpr" [style.opacity]="isLoading ? 0 : 1">
      <div class="dashboardSearchCont">
       <div class="toggleCont" [ngClass]="{'closed': !isFilterDropdownOpen}" tabindex="0"
           (click)="$event.stopPropagation()">
            <span class="selected-chips">
                <ng-container *ngIf="selectedRegions().length + selectedBusinessLines().length + selectedProductLines().length + selectedFunctions().length === 0">
                    <span>All</span>
                </ng-container>
                <ng-container *ngIf="selectedRegions().length + selectedBusinessLines().length + selectedProductLines().length + selectedFunctions().length > 0">
                    <ng-container *ngFor="let item of selectedRegions().concat(selectedBusinessLines(), selectedProductLines(), selectedFunctions()).slice(0,1)">
                        <span style="cursor: pointer;" class="chip" (click)="toggleFilterDropdown(); $event.stopPropagation()">{{ item }}</span>
                    </ng-container>
                    <span style="cursor: pointer;" (click)="toggleFilterDropdown(); $event.stopPropagation()" *ngIf="selectedRegions().length + selectedBusinessLines().length + selectedProductLines().length + selectedFunctions().length > 1">
                        +{{ selectedRegions().length + selectedBusinessLines().length + selectedProductLines().length + selectedFunctions().length - 1 }}
                    </span>
                </ng-container>
            </span>
            <img src="/assets/images/chevron-south.svg" alt="" (click)="toggleFilterDropdown(); $event.stopPropagation()">
            <div class="optionCont" *ngIf="isFilterDropdownOpen">
               <div class="scrollGrp">
                  <button class="optionBtn" (click)="resetAllFilters()"
                  [ngClass]="{ checked: !(selectedRegions().length ||
                               selectedBusinessLines().length ||
                               selectedFunctions().length ||
                               selectedCategories().length)}">
                     All
                  </button>
                  <span>Regions</span>
                  <button class="optionBtn" *ngFor="let region of allRegions" 
                     (click)="onRegionCheckboxChange($event, region, true)"
                     [ngClass]="{ checked: selectedRegions().includes(region.regionName) }">
                     <span class="styledCheckbox"></span>
                     <input type="checkbox" [checked]="selectedRegions().includes(region.regionName)" id="{{ region }}"/>
                     <label for="{{ region }}"> {{ region.regionName }}</label>
                  </button>

                  <span>Business Lines</span>
                  <button class="optionBtn" *ngFor="let businessLine of allBusinessLines"
                     (click)="onBusinessLinesCheckboxChange($event, businessLine, true)" 
                     [ngClass]="{checked: selectedBusinessLines().includes(businessLine.businessLineName)}" >
                      <span class="styledCheckbox"></span>
                      <input type="checkbox" [checked]="selectedBusinessLines().includes(businessLine.businessLineName)" id="{{ businessLine }}"/>
                      <label for="{{ businessLine }}">   {{ businessLine.businessLineName }}</label>
                  </button>

                   <span>Product Lines</span>
                  <button class="optionBtn" *ngFor="let productLine of allProductLines"
                     [ngClass]="{checked: selectedProductLines().includes(productLine.productLineName)}"
                     (click)="onProductLinesCheckboxChange($event, productLine, true)">
                     <span class="styledCheckbox"></span>
                     <input type="checkbox" [checked]="selectedProductLines().includes(productLine.productLineName)" id="{{ productLine }}"/>
                     <label for="{{ productLine }}">    {{ productLine.productLineName }}</label>
                   
                  </button>                    

                  <span>Functions</span>
                  <button class="optionBtn" *ngFor="let function of allFunctions"
                     [ngClass]="{checked: selectedFunctions().includes(function.functionName) }"
                     (click)="onFunctionsCheckboxChange($event, function, true)">
                     <span class="styledCheckbox"></span>
                     <input type="checkbox" [checked]="selectedFunctions().includes(function.functionName)" id="{{ function }}" />
                     <label for="{{ function }}">    {{ function.functionName }}</label>
                  </button>
               </div>
            </div>
        </div>
        <input type="text" class="inputField" placeholder="Search for analytics"
        [matAutocomplete]="auto" (input)="onInputChange($event)">
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
            <mat-option *ngFor="let analyticsProduct of filteredOptions | async as modules" [value]="analyticsProduct"
            (onSelectionChange)="onDashboardSelection(analyticsProduct)" >
                        {{analyticsProduct}}
            </mat-option>
        </mat-autocomplete>
        <button class="searchBtn" (click)="onSearch()">
            <img src="/assets/images/searchIcon-white.svg" alt="">
        </button>
    </div>
    <div class="contentCard mydashTabsCont">
        <div class="dashboardList" *ngIf="userId && isUserLoggedIn && isExistingUser" >
            <div class="tabSelectorCont" >
                <a class="tabItem" id="tour-myAnalyticsTab"
                    [class.active]="selectedTab() === 'My Dashboards'"
                     (click)="selectedTab.set('My Dashboards');selectedAnalyticsTab = ('My Dashboards');onTabChange()">
                    My Analytics <span>{{myDashboardCount()}}</span>
                </a>
                <a class="tabItem"
                    [class.active]="selectedTab() === 'Bookmarks'"
                    (click)="selectedTab.set('Bookmarks');selectedAnalyticsTab =('Bookmarks');onTabChange()">
                    Bookmarks <span>{{bookmarkedCount()}}</span>
                </a>
            </div>
            <ng-container *ngIf="selectedTab() === 'My Dashboards'">
                <div class="recommendedGrid">
                    <p class="subHead" [ngClass]="{'gridSpan3': myDashboardCount() > 4}">Dashboards you currently have access to and those pending approval</p>
                    <ng-container *ngIf="myDashboardCount() > 4">
                        <button class="seeAllBtn" (click)="onExploreAllAnalytics('My Dashboards')">
                            {{myDashboardCount() - 4}} more
                            <span><img src="/assets/images/ArrowlinkIcon.svg" alt=""></span>
                        </button>
                    </ng-container>
                    <div class="recommendedCard" *ngFor="let analyticsProduct of visibleCards">
                        <h3> {{ analyticsProduct.moduleName }}</h3>                        
                        <div style="display: flex; align-items: center; gap: 8px;width: 100%;justify-content: space-between;">
                            <button class="dmintLinkBtn" (click)="viewDetails(analyticsProduct)"
                            *ngIf="!(analyticsProduct.subscription && userId && isUserLoggedIn)">
                                View Details
                            </button>
                            <button class="btn-label pending-tag" *ngIf="analyticsProduct.subscription == false && analyticsProduct.accessCompleted != undefined && analyticsProduct.accessCompleted == false">
                                <img src="/assets/images/locked.svg" alt="" />
                                Access Pending
                            </button>
                            <button class="dmintLinkBtn" *ngIf="analyticsProduct.subscription && userId && isUserLoggedIn" (click)="loadModule(analyticsProduct)">
                                Open Analytics
                            </button>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="selectedTab() === 'Bookmarks'">
                <div class="recommendedGrid">
                    <p class="subHead" [ngClass]="{'gridSpan3': bookmarkedCount() > 4}">Your favorite dashboards</p>
                    <ng-container *ngIf="bookmarkedCount() > 4">
                        <button class="seeAllBtn" (click)="onExploreAllAnalytics('Bookmarks')">
                            {{bookmarkedCount() - 4}} more
                            <span><img src="/assets/images/ArrowlinkIcon.svg" alt=""></span>
                        </button>
                    </ng-container>
                    <div class="recommendedCard" *ngFor="let analyticsProduct of visibleBookmarks">
                        <div class="bookmarkCardHead">
                            <h3>{{ analyticsProduct.moduleName }}</h3>
                            <button class="bookmarkBtn" (click)="toggleFavourite(analyticsProduct)">
                                <img style="height: 24px; width: 24px; object-fit: none;"  [src]="analyticsProduct.favorite ? '/assets/images/bookmarksIcon-filled.svg' : '/assets/images/bookmarksIcon.svg'">
                            </button>
                        </div>
                    
                        <div style="display: flex; align-items: center; gap: 8px;width: 100%;justify-content: space-between;">
                            <button class="dmintLinkBtn" (click)="viewDetails(analyticsProduct)"
                            *ngIf="!(analyticsProduct.subscription && userId && isUserLoggedIn)">
                                    View Details
                            </button>
                            <button class="btn-label pending-tag" *ngIf="analyticsProduct.subscription == false && analyticsProduct.accessCompleted != undefined && analyticsProduct.accessCompleted == false">
                                    <img src="/assets/images/locked.svg" alt="" />
                                    Access Pending
                            </button>
                            <button class="dmintLinkBtn" *ngIf="analyticsProduct.subscription && userId && isUserLoggedIn" (click)="loadModule(analyticsProduct)">
                                    Open Analytics
                            </button>                            
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="categoryList">
            <h2>Discover the Right Analytics for Your Needs</h2>
            <div  class="categoryCard" *ngFor="let categoryModule of categoryModulesList; let i = index" id="tour-categoryCard-{{i}}">
                <div class="cardImage">
                    <img [src]="categoryModule.categoryImagePath | base64: 'image/svg+xml'" alt="">
                </div>
                <div class="categoryDetails">
                    <h3 class="large">{{categoryModule.categoryName}}</h3>
                    <p>{{categoryModule.categoryDescription}}</p>
                </div>
                <div class="quickLinks">
                    <a *ngFor="let module of categoryModule.moduleList?.slice(0,4)" class="tagBtnwithIcon" (click)="viewModuleDetails(module)">
                        <span><img src="/assets/images/externalLinkIcon-black.svg" alt=""></span>
                        {{module.moduleName}}
                    </a>
                </div>
                <a *ngIf="categoryModule.moduleList?.length>0" class="dmintLinkBtn" (click)="onExploreAll(categoryModule)">Explore All <span><img src="/assets/images/ArrowlinkIcon.svg" alt=""></span></a>
                <p  *ngIf="categoryModule.moduleList?.length==0" class="tag new floating justStart">Coming Soon</p>
            </div>
            <button class="secondary" (click)="onExploreAllAnalytics('')">Explore all Analytics</button>
        </div>
        <div *ngIf="false" class="recommendedDashboards">
            <h2>Recommended Dashboards</h2>
            <p>Based on your profile and role, here are few recommended dashboards</p>
            <div class="recommendedGrid">
                <button class="seeAllBtn" style="top: -38px;" (click)="seeAllRecommended()">{{recommendations.length - 4}} more <span><img src="/assets/images/ArrowlinkIcon.svg" alt=""></span></button>
                    
                <div class="recommendedCard" *ngFor="let rec of visibleRec">
                    <h3>{{ rec.name }}</h3>
                    <button class="dmintLinkBtn">
                        View Details
                    </button>
                </div>
            </div>
        </div>
        <div  *ngIf="false" class="testimonialList">
            <h2>What our users say</h2>
            <div class="testiGrid">
                <button (click)="prevTesti()" [disabled]="currentIndex === 0" class="arrowBtn">
                    <img src="/assets/images/chevron-south.svg" alt="" style="transform: rotate(90deg);">
                </button>
                <div class="testimonialCard" *ngFor="let testi of visibleTesti">
                    <div class="testimonialDetails">
                        <p class="testi">{{testi.testimonial}}</p>
                        <h3>{{testi.name}}</h3>
                        <p>{{testi.position}}</p>
                    </div>
                </div>
                <button 
                    (click)="nextTesti()" 
                    [disabled]="(currentIndex + 1) * pageSize >= visibleTesti.length" 
                    class="arrowBtn right">
                    <img src="/assets/images/chevron-south.svg" alt="" style="transform: rotate(-90deg);">
                </button>
            </div>
        </div>
        <div class="supportCont">
            <div class="flexSP justStart">
                <div class="sectionHead">
                    <h2>Need more details?</h2>
                    <a href="" class="dmintLinkBtn">VISIT OUR Support & FAQ SECTION</a>
                </div>
            </div>
            <img src="/assets/images/dmint_customer_care_illiustration.svg" class="illus" alt="">
        </div>
    </div>
</section>
<app-success-toast [message]="successMessage" *ngIf="successMessage"></app-success-toast>

<app-alert [message]="errMsg" *ngIf="showErrorMessageWithPopup" (close)="onCloseHandlerSub()"></app-alert>